import { Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { ModalLoading } from "../../../../../../common/components/modal_loading";
import FormContainer from "../../../../../../common/components/form_container";
import DefaultFormInput from "../../../../../../common/components/default_form_input";
import { useCallback, useEffect } from "react";
import { FormDatePickerInput } from "../../../../../../common/components/masked_inputs/react_forms/form_date_picker_input";
import PrimaryButton from "../../../../../../common/components/primary_button";
import { defaultDisciplinaCopiaForm, DisciplinaCopiaRequestForm, DisciplinaCopiaRequestSchema } from "../../../schemas/Projetos_cadastro/Disciplina_e_SubDisciplina_copia";
import { GetProjetoDisciplinaByIdResponseModel } from "../../../../domain/models/disciplina_models";

type props = {
    open: boolean,
    saving: boolean,
    selectedDisciplinaCopia: GetProjetoDisciplinaByIdResponseModel | undefined,
    titulo: string,
    onClose: () => void,
    onSubmit: (form: DisciplinaCopiaRequestForm) => void,

}

export const CopiaDisciplinaModal = ({
    open,
    saving,
    selectedDisciplinaCopia,
    titulo,
    onClose,
    onSubmit,

}: props) => {

    const hookForm = useForm<DisciplinaCopiaRequestForm>({
        mode: "onSubmit",
        reValidateMode: "onSubmit",
        defaultValues: defaultDisciplinaCopiaForm,
        resolver: zodResolver(DisciplinaCopiaRequestSchema),
    });

    useEffect(() => {
        if (selectedDisciplinaCopia) {
            hookForm.setValue('idDisciplina', (selectedDisciplinaCopia as any).IdDisciplina);
            hookForm.setValue('idProjeto', (selectedDisciplinaCopia as any).IdProjeto ?? 0);
            hookForm.setValue('descricao', (selectedDisciplinaCopia as any).Descricao ?? "");
            hookForm.setValue('revisao', (selectedDisciplinaCopia as any).Revisao ?? "");
            hookForm.setValue('plantas', (selectedDisciplinaCopia as any).Plantas ?? "");
            hookForm.setValue('dataDisciplina', (selectedDisciplinaCopia as any).DataDisciplina ? new Date((selectedDisciplinaCopia as any).DataDisciplina) : null);
        }

    }, [selectedDisciplinaCopia, titulo, hookForm]);

    const handleSubmit = useCallback((form: DisciplinaCopiaRequestForm) => {
        if (!saving) {
            onSubmit(form);
            hookForm.reset();
        }

    }, [saving, onSubmit, hookForm]);

    const handleClose = useCallback(() => {
        if (!saving) onClose();
    }, [saving, onClose]);

    return (
        <Dialog
            open={open}
            fullWidth={true}
            slotProps={{
                paper: {
                    component: 'form',
                    sx: { width: 400 },
                    onSubmit: hookForm.handleSubmit(handleSubmit, (_) => { })
                }
            }}
            sx={{
                "& .MuiDialog-container": {
                    "& .MuiPaper-root": {
                        width: "100%",
                        maxWidth: "45rem",
                    },
                },
            }}>

            <DialogTitle>
                Copiar disciplina
            </DialogTitle>

            <DialogContent>
                <ModalLoading loading={saving}  >
                    <FormContainer title={"Informações"} arrangement="fullRow">
                        <>
                            <DefaultFormInput
                                name='descricao'
                                label='Descrição'
                                reactHookForm={hookForm}
                            />
                            <DefaultFormInput
                                name='plantas'
                                label='Plantas'
                                reactHookForm={hookForm}

                            />
                            <DefaultFormInput
                                name='revisao'
                                label='Revisão'
                                reactHookForm={hookForm}

                            />
                            <FormDatePickerInput
                                name='dataDisciplina'
                                label='Data da Revisão'
                                required={false}
                                reactHookForm={hookForm}
                            />
                        </>
                    </FormContainer>

                </ModalLoading>
            </DialogContent>

            <DialogActions>
                <div className="w-full h-full items-center justify-end flex px-4 pb-4 gap-4">

                    <div className="flex flex-row gap-2">
                        <div className="p-2 hover:bg-hover-light-gray cursor-pointer dark:hover:bg-border-dark-gray rounded-[4px] font-semibold">
                            <h1
                                className="text-sm text-black dark:text-white"
                                onClick={handleClose}>
                                Cancelar
                            </h1>
                        </div>

                        <div className="w-[120px]">
                            {saving ? (
                                <PrimaryButton
                                    buttonColor="primary-green">
                                    Salvando...
                                </PrimaryButton>
                            ) : (
                                <PrimaryButton
                                    type="submit"
                                    buttonColor="primary-green">
                                    Salvar
                                </PrimaryButton>
                            )}
                        </div>
                    </div>
                </div>
            </DialogActions>

        </Dialog>
    );
}